export var HomeController = {
    init: function () {
        return new Promise(function (resolve, reject) {
            try {
                //Example to init a function
                //this.initMyFunction();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    //Example to create a function
    //initMyFunction() { ... }
};
